import React from 'react';
import ReactDOM from 'react-dom';
import Routes from './routes/route';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'mdb-react-ui-kit/dist/css/mdb.min.css';
import 'react-tabs/style/react-tabs.css';
import './pages/style.css';
import './pages/ballons.css';
import { LanguageProvider } from './context/language';
import { InstalmentProvider } from './context/InstalmentContext';

ReactDOM.render(
  <LanguageProvider>
    <InstalmentProvider>
      <React.StrictMode>
        <Routes />
      </React.StrictMode>
    </InstalmentProvider>
  </LanguageProvider>,
  document.getElementById('root')
);